module.exports = __webpack_public_path__ + "bd77fe6f1244c26294032fe46f8bd6fd.svg";